import {Component} from '@angular/core';

@Component({
    selector: 'sp-download-buttons',
    templateUrl: '../../../templates/common/download_buttons.component.html'
})
export class DownloadButtonsComponent {
}